// extracted by mini-css-extract-plugin
module.exports = {"card":"dd31006766--card--hBVgM","checked":"dd31006766--checked--FH3NH"};